module.exports = __webpack_public_path__ + "img/sixpackcarrier02.0d016467.jpg";